import permission from './permission'
import role from './role'

const install = (app: any) => {
  app.directive('permission', permission)
  app.directive('role', role)
}

export default install
